import styled from 'styled-components';
import { Text } from '@usealloy/component-library';

export const StyledLinkText = styled(Text)`
  &&&& {
    color: var(--cl-juicyBlue-600);

    &:hover {
      text-decoration: underline
    }
  }
`;
